"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRefetch = require("react-refetch");

var _reactHighcharts = _interopRequireDefault(require("react-highcharts"));

var _PropTypes = require("./PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var cumulativeDistributionPoints = function cumulativeDistributionPoints(_ref) {
  var bins = _ref.bins,
      counts = _ref.counts;
  return bins.map(function (bin, ix) {
    return {
      x: bin,
      y: counts.slice(ix).reduce(function (v, acc) {
        return v + acc;
      }, 0)
    };
  }).filter(function (v) {
    return v.x > 0 && v.y > 0;
  }); // Remove first bin for the logarithmic chart, otherwise Highcarts complains
};

var CutoffDistribution = function CutoffDistribution(_ref2) {
  var unit = _ref2.unit,
      cutoff = _ref2.cutoff,
      onChangeCutoff = _ref2.onChangeCutoff,
      histogram = _ref2.histogram;
  return /*#__PURE__*/_react["default"].createElement("div", null, "Current value: ".concat(cutoff.value).concat(unit ? " ".concat(unit) : ""), /*#__PURE__*/_react["default"].createElement(_reactHighcharts["default"], {
    config: {
      title: "",
      xAxis: {
        title: {
          text: "Cutoff value"
        },
        type: "logarithmic"
      },
      yAxis: {
        title: {
          text: "# genes"
        }
      },
      type: "line",
      series: [{
        cursor: "pointer",
        name: "Genes expressed in this experiment at value higher than cutoff",
        data: cumulativeDistributionPoints(histogram)
      }],
      tooltip: {
        useHTML: true,
        formatter: function formatter() {
          return "<div>Cutoff: <b> ".concat(this.x, "</b> (").concat(this.y, " genes past this cutoff)</div>");
        }
      },
      credits: {
        enabled: false
      }
    }
  }));
};

CutoffDistribution.propTypes = {
  cutoff: _PropTypes.CutoffType,
  //onChangeCutoff: PropTypes.func.isRequired,
  unit: _PropTypes.UnitType.isRequired,
  histogram: _propTypes["default"].shape({
    bins: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired).isRequired,
    counts: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired).isRequired
  })
};

var CutoffDistributionLoader = /*#__PURE__*/function (_Component) {
  _inherits(CutoffDistributionLoader, _Component);

  var _super = _createSuper(CutoffDistributionLoader);

  function CutoffDistributionLoader() {
    _classCallCheck(this, CutoffDistributionLoader);

    return _super.apply(this, arguments);
  }

  _createClass(CutoffDistributionLoader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          genesDistributedByCutoffFetch = _this$props.genesDistributedByCutoffFetch,
          loadingGifUrl = _this$props.loadingGifUrl,
          cutoff = _this$props.cutoff,
          onChangeCutoff = _this$props.onChangeCutoff,
          unit = _this$props.unit;

      if (genesDistributedByCutoffFetch.pending) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: loadingGifUrl
        });
      } else if (genesDistributedByCutoffFetch.rejected) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Error: ", genesDistributedByCutoffFetch.reason);
      } else if (genesDistributedByCutoffFetch.fulfilled) {
        return /*#__PURE__*/_react["default"].createElement(CutoffDistribution, {
          histogram: genesDistributedByCutoffFetch.value,
          cutoff: cutoff,
          onChangeCutoff: onChangeCutoff,
          unit: unit
        });
      }
    }
  }]);

  return CutoffDistributionLoader;
}(_react.Component);

var _default = (0, _reactRefetch.connect)(function (props) {
  return {
    genesDistributedByCutoffFetch: props.genesDistributedByCutoffUrl
  };
})(CutoffDistributionLoader);

exports["default"] = _default;